import { Injectable } from '@angular/core';
import { PronunciationResult } from '@app/model/pronunciation-result';
import { HttpService } from 'library-explorer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpeechaceApiService {

  constructor(private readonly httpService: HttpService) { }

  public checkSlidePronunciation(slideId: string, file: File): Observable<PronunciationResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('include_unknown_words', '1');
    formData.append('fileName', file.name);

    return this.httpService.postMuiltiPart<PronunciationResult>(`speechace/check-slide-pronunciation/${slideId}`, formData);
  }
}